var map = {
	"./Customers/Etebar-gary.png": 1094,
	"./Customers/Etebar.png": 1095,
	"./Customers/Mapna-gray.png": 1096,
	"./Customers/Sina- gray.png": 1097,
	"./Customers/Sina.png": 1098,
	"./Customers/afam-color.png": 1099,
	"./Customers/afam-gray.png": 1100,
	"./Customers/banner-eseminar.webp": 1101,
	"./Customers/banner-helal.webp": 1102,
	"./Customers/banner-kale.webp": 1103,
	"./Customers/banner-mapna.webp": 1104,
	"./Customers/bime.webp": 1105,
	"./Customers/eseminar-d.webp": 1106,
	"./Customers/eseminar.webp": 1107,
	"./Customers/helal-d.webp": 1108,
	"./Customers/helal.webp": 1109,
	"./Customers/industry.webp": 1110,
	"./Customers/it.webp": 1111,
	"./Customers/kale-d.webp": 1112,
	"./Customers/kale.webp": 1113,
	"./Customers/mapna-color.png": 1114,
	"./Customers/mapna-d.webp": 1115,
	"./Customers/mapna.webp": 1116,
	"./Customers/software.webp": 1117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 919;